import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { ratePlanEndpoints } from './endpoints.js';
import { ratePlanDetail, type RatePlanDetail } from './schemas.js';

export function useRatePlanDetail(ratePlanId: string): UseQueryResult<RatePlanDetail> {
  return useApiQuery({
    queryKey: queryKeys.ratePlans.detail(ratePlanId),
    path: ratePlanEndpoints.detail(ratePlanId),
    schema: ratePlanDetail,
  });
}
